import React from "react";
import { ProgressBar } from "../../../uncommon/native";
import { Arrow } from "../../../../assets";
import { View, StyleSheet, TouchableOpacity } from "react-native";

const getProgressBarInfo = (currentStep: number) => {
  switch (currentStep) {
    case 1:
      return { progress: 0.2, title: "1. Upload Images" };
    case 2:
      return { progress: 0.5, title: "2. Choose Template" };
    case 3:
      return { progress: 0.8, title: "3. Configure Template" };
    case 4:
      return { progress: 1, title: "4. Adjust Images" };
    default:
      return { progress: 0, title: "Unknown Step" };
  }
};

const NavigationProgress: React.FC<{
  step: number;
  loading: boolean;
  setStep: (step: number) => void;
}> = ({ step, setStep, loading }) => {
  const { progress, title } = getProgressBarInfo(step);
  return (
    <View style={styles.header}>
      <View style={styles.progressContainer}>
        <TouchableOpacity
          accessibilityRole="button"
          accessibilityLabel={`Back to ${getProgressBarInfo(Math.max(1, step - 1)).title.replace(/^\d+\.\s*/, "")}`}
          accessibilityState={{ disabled: loading || step === 1 }}
          onPress={() => setStep(Math.max(1, step - 1))}
          disabled={loading || step === 1}
        >
          <Arrow direction="left" />
        </TouchableOpacity>
        <ProgressBar progress={progress} title={title} timeLeft={""} />
        <TouchableOpacity
          accessibilityRole="button"
          accessibilityLabel={`Next to ${getProgressBarInfo(Math.min(4, step + 1)).title.replace(/^\d+\.\s*/, "")}`}
          accessibilityState={{ disabled: loading || step === 4 }}
          onPress={() => setStep(Math.min(4, step + 1))}
          disabled={loading || step === 4}
        >
          <Arrow direction="right" />
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  header: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: 15,
    padding: 10,
    left: 10,
    marginBottom: 5,
  },
  progressContainer: {
    marginHorizontal: "auto",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: 10,
  },
});

export default NavigationProgress;
